export function nextCaptureIndex(existing: number[]): number {
  if (existing.length === 0) return 1;
  return Math.max(...existing) + 1;
}

export function patchesForZeroBasedPages(
  pages: { id: string; scriptId: string; pageIndex: number }[],
): { id: string; pageIndex: number }[] {
  const byScript = new Map<string, typeof pages>();
  for (const page of pages) {
    const list = byScript.get(page.scriptId);
    if (list) list.push(page);
    else byScript.set(page.scriptId, [page]);
  }
  const patches: { id: string; pageIndex: number }[] = [];
  for (const list of byScript.values()) {
    const taken = new Set(list.filter(p => p.pageIndex >= 1).map(p => p.pageIndex));
    let next = 1;
    for (const page of list.filter(p => p.pageIndex < 1)) {
      while (taken.has(next)) next++;
      patches.push({ id: page.id, pageIndex: next });
      taken.add(next);
      next++;
    }
  }
  return patches;
}
